import React, { Component } from 'react';
import Layout from '../layout';
import HardwareHero from '../assets/v2/png/HardwareHero.png';
import HealthSectionOne from '../components/Esper/Healthcare/HealthSectionOne';
import HealthSectionTwo from '../components/Esper/Healthcare/HealthSectionTwo';
import HealthSectionThree from '../components/Esper/Healthcare/HealthSectionThree';
import HealthSectionFour from '../components/Esper/Healthcare/HealthSectionFour';
import HealthSectionFive from '../components/Esper/Healthcare/HealthSectionFive';
import HealthSectionSix from '../components/Esper/Healthcare/HealthSectionSix';
import HealthSectionSeven from '../components/Esper/Healthcare/HealthSectionSeven';
import BlogPosts from './../components/Esper/HomePage/BlogPosts';
import messages from '../i18n/en';

export default class Hardware extends Component<any, any> {
  render() {
    return (
      <Layout
        ogImage={HardwareHero}
        messages={messages}
        title={
          'Move beyond MDM for Healthcare to Android DevOps for Healthcare'
        }
        description={`Esper offers the healthcare ecosystem with a single platform to manage their mobile devices & setup seamless deployment & protect patient data & outcomes and thus streamling the Android mHealth Product Lifecycle `}
        keywords={`heatlhcare tecnology,MDM for Healthcare,healthcare security,healthcare IoT,Android mHealth,`}
        className="first-page"
        location={this.props.location}
      >
        <HealthSectionOne />
        <HealthSectionTwo />
        <HealthSectionThree />
        <HealthSectionFour />
        <HealthSectionFive />
        <HealthSectionSix />
        <HealthSectionSeven messages={messages} />
        <BlogPosts />
      </Layout>
    );
  }
}
